import { render, staticRenderFns } from "./RealityAutobuyerBox.vue?vue&type=template&id=3298b15c&scoped=true"
import script from "./RealityAutobuyerBox.vue?vue&type=script&lang=js"
export * from "./RealityAutobuyerBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3298b15c",
  null
  
)

export default component.exports